// 0_global/translations.js
// All UI strings, bundled into main.min.js (NOT loaded as JSON) so they are
// available SYNCHRONOUSLY the instant the script runs — no extra request, no flash
// of missing text. Access anywhere via:  window.NAT.translations("key")
//
// Language: set ONCE per store in the admin "HTML code" → common-header, BEFORE
// main.min.js loads:  <script>window.NAT = { lang: "cs" };</script>
// The guard below (|| {}) means this file never clobbers that admin-provided value.

window.NAT = window.NAT || {};
// Fallback if the admin snippet wasn't set: try <html lang>, then "cs".
window.NAT.lang = window.NAT.lang || document.documentElement.lang || "cs";

const translationsStrings = {
	phoneCode: {
		cs: "+420 ",
		sk: "+421 ",
		pl: "+48 ",
	},
	contactHours: {
		cs: "Po–Pá 8:00–16:00",
		sk: "Po–Pá 8:00–16:00",
		pl: "Pn–Pt 8:00–16:00",
	},
	showAllCategories: {
		cs: "Zobrazit další kategorie",
		sk: "Zobraziť ďalšie kategórie",
		pl: "Pokaż więcej kategorii",
	},
	showNext: {
		cs: "Zobrazit další",
		sk: "Zobraziť ďalšie",
		pl: "Pokaż więcej",
	},
	moreButtonMoreThanFour: {
		cs: "dalších ",
		sk: "ďalších ",
		pl: "kolejnych ",
	},
	moreButtonLessThanFour: {
		cs: "další ",
		sk: "ďalšie ",
		pl: "kolejne ",
	},
	moreButtonOne: {
		cs: "další ",
		sk: "ďalšia ",
		pl: "kolejna ",
	},
	more: {
		cs: "Více",
		sk: "Viac",
		pl: "Więcej",
	},
	moreThan: {
		cs: "více než ",
		sk: "viac ako ",
		pl: "więcej niż ",
	},
	deliveryTooltipSaturday: {
		cs: "V Praze, Brně a Ostravě doručujeme bez příplatků do boxů a výdejních míst také v sobotu.",
		sk: "",
		pl: "",
	},
	cartTotalLabel: {
		cs: "Cena celkem",
		sk: "Cena spolu",
		pl: "Cena łącznie",
	},
	compare: {
		cs: "Porovnat",
		sk: "Porovnať",
		pl: "Porównaj",
	},
	customFilterButton: {
		cs: "Filtrování výsledků",
		sk: "Filtrovanie výsledkov",
		pl: "Filtrowanie wyników",
	},
	selectedFilters: {
		cs: "Vybrané filtry",
		sk: "Vybrané filtre",
		pl: "Wybrane filtry",
	},
	product: {
		cs: "Produkt",
		sk: "Produkt",
		pl: "Produkt",
	},
	verifiedReviews: {
		cs: "Ověřená hodnocení",
		sk: "Overené hodnotenia",
		pl: "Zweryfikowane opinie",
	},
	shopRatingUrl: {
		cs: "/hodnoceni-obchodu",
		sk: "/hodnotenie-obchodu",
		pl: "/opinie-o-sklepie",
	},
	noSaleCoupon: {
		cs: "U tohoto produktu není možné využít slevový kód",
		sk: "U tohto produktu nie je možné využiť zľavový kód",
		pl: "Nie można użyć kodu rabatowego na ten produkt.",
	},
	noLoyaltySale: {
		cs: "U tohoto produktu není možné uplatnit věrnostní slevu.",
		sk: "U tohto produktu nie je možné uplatniť vernostnú zľavu.",
		pl: "U tego produktu nie można zastosować zniżki lojalnościowej.",
	},
	denDetiKupon: {
		cs: "Na tento produkt lze uplatnit kód <b>PRODETI10</b> pro 10% slevu.",
		sk: "Na tento produkt je možné uplatniť kód <b>PREDETI10</b> pre 10% zľavu.",
		pl: "Na ten produkt można użyć kod rabatowy <b>DLADZIECI10</b> ze zniżką 10%.",
	},
	descriptionTitle: {
		cs: "Popis",
		sk: "Popis",
		pl: "Opis",
	},
	productSetTitle: {
		cs: "Co najdete v setu",
		sk: "Čo nájdete v sete",
		pl: "Co znajdziesz w zestawie",
	},
	directionsTitle: {
		cs: "Dávkování",
		sk: "Dávkovanie",
		pl: "Dawkowanie",
	},
	ingredientsTitle: {
		cs: "Složení",
		sk: "Zloženie",
		pl: "Skład",
	},
	certificatesTitle: {
		cs: "Certifikáty",
		sk: "Certifikáty",
		pl: "Certyfikaty",
	},
	reviewsTitle: {
		cs: "Hodnocení",
		sk: "Hodnotenie",
		pl: "Opinie",
	},
	weSupportTitle: {
		cs: "Pomáháme",
		sk: "Pomáhame",
		pl: "Pomagamy",
	},
	relatedProductsTitle: {
		cs: "Související produkty",
		sk: "Súvisiace produkty",
		pl: "Produkty powiązane",
	},
	showRelatedProducts: {
		cs: "Zobrazit související produkty",
		sk: "Zobraziť súvisiace produkty",
		pl: "Pokaż produkty powiązane",
	},
	relatedFilesTitle: {
		cs: "Dokumenty",
		sk: "Dokumenty",
		pl: "Dokumenty",
	},
	show: {
		cs: "Zobrazit",
		sk: "Zobraziť",
		pl: "Pokaż",
	},
	showCertificate: {
		cs: "Zobrazit certifikát",
		sk: "Zobraziť certifikát",
		pl: "Pokaż certyfikat",
	},
	outOf: {
		cs: "z",
		sk: "z",
		pl: "z",
	},
	natiosDescription: {
		cs: "Natios je česká značka, která se zaměřuje na výrobu kvalitních doplňků stravy s čistým složením bez zbytečných příměsí, konzervantů a éček.",
		sk: "Natios je česká značka, ktorá sa zameriava na výrobu kvalitných doplnkov stravy s čistým zložením bez zbytočných prísad, konzervantov a éčok.",
		pl: "Natios to czeska marka, która koncentruje się na produkcji wysokiej jakości suplementów diety o czystym składzie – bez zbędnych domieszek, konserwantów i sztucznych dodatków (E).",
	},

	natiosSupportTextTop: {
		cs: "Nákupem <b>přispějete</b> 1 Kč dětské hematoonkologii.",
		sk: "Nákupom <b>prispievate</b> 1 Kč detskej hematoonkológii.",
		pl: "Kupując, <b>wspierasz</b> dziecięcą hematoonkologię kwotą 1 CZK.",
	},
	natiosSupportHeaderBottom: {
		cs: "<h3>Pomáháme</h3><span>&nbsp;dětské hematoonkologii</span>",
		sk: "<h3>Pomáhame</h3><span>&nbsp;detskej hematoonkológii</span>",
		pl: "<h3>Pomagamy</h3><span>&nbsp;pediatrycznej hematoonkologii</span>",
	},
	natiosSupportTextBottom: {
		cs: "Natios z každého prodaného produktu daruje 1 Kč dětské hematoonkologii ve Fakultní nemocnici v Ostravě. Léčba každého onkologického pacienta v České republice se odhaduje na přibližně 8&nbsp;000&nbsp;Kč měsíčně. Věříme tedy, že tímto krokem společně dokážeme pomoci několika rodinám.",
		sk: "Natios z každého predaného produktu daruje 1 Kč detskej hematoonkológii vo Fakultnej nemocnici v Ostrave. Liečba každého onkologického pacienta v České republice sa odhaduje na približne 8&nbsp;000&nbsp;Kč mesačne. Veríme teda, že týmto krokom spoločne dokážeme pomôcť niekoľkým rodinám.",
		pl: "Natios z każdego sprzedanego produktu przekazuje 1 CZK na rzecz pediatrycznej hematoonkologii w Szpitalu Uniwersyteckim w Ostrawie. Leczenie jednego pacjenta onkologicznego w Czechach szacuje się na około 8&nbsp;000&nbsp;CZK miesięcznie. Wierzymy, że tym krokiem wspólnie możemy pomóc wielu rodzinom.",
	},
	natiosSupportTotalAmount: {
		cs: "Společně jsme již dokázali přispět přes 1&nbsp;053&nbsp;000&nbsp;Kč. Děkujeme!",
		sk: "Spoločne sme už dokázali prispieť cez 1&nbsp;053&nbsp;000&nbsp;Kč. Ďakujeme!",
		pl: "Wspólnie udało nam się już przekazać ponad 1&nbsp;053&nbsp;000&nbsp;CZK. Dziękujemy!",
	},
	natiosSupportBlogUrl: {
		cs: "/blog/natios-pomaha-hematoonkologii-v-ostrave/",
		sk: "/blog/natios-pomaha-hematoonkologii-v-ostrave/",
		pl: "/",
	},
	moreAboutSupport: {
		cs: "Více o pomoci",
		sk: "Viac o pomoci",
		pl: "Więcej o pomocy",
	},
	insertFirstReview: {
		cs: "Vložit první hodnocení",
		sk: "Vložiť prvé hodnotenie",
		pl: "Wstaw pierwszą opinię",
	},
	watchDog: {
		cs: "Hlídat dostupnost",
		sk: "Strážiť dostupnosť",
		pl: "Obserwuj dostępność",
	},
	readMore: {
		cs: "Číst dále",
		sk: "Čítať ďalej",
		pl: "Czytaj dalej",
	},
	productVariants: {
		cs: "Varianty produktu",
		sk: "Varianty produktu",
		pl: "Warianty produktu",
	},
	showMoreVariants: {
		cs: "Zobrazit více variant",
		sk: "Zobraziť viac variantov",
		pl: "Pokaż więcej wariantów",
	},
	withVAT: {
		cs: "s DPH",
		sk: "s DPH",
		pl: "z VAT",
	},
	quantityDiscountNoDiscount: {
		cs: "bez slevy",
		sk: "bez zľavy",
		pl: "bez rabatu",
	},
	quantityDiscountSavePrefix: {
		cs: "Ušetříte:",
		sk: "Ušetríte:",
		pl: "Oszczędzasz:",
	},
	toCart: {
		cs: "Do košíku",
		sk: "Do košíka",
		pl: "Do koszyka",
	},
	alertMe: {
		cs: "Upozornit",
		sk: "Upozorniť",
		pl: "Powiadom",
	},
	gitFiltersUrl: {
		cs: "https://raw.githubusercontent.com/NatimaFilip/natima_eshop_files/refs/heads/main/filters_cz.json",
		sk: "https://raw.githubusercontent.com/NatimaFilip/natima_eshop_files/refs/heads/main/filters_sk.json",
		pl: "https://raw.githubusercontent.com/NatimaFilip/natima_eshop_files/refs/heads/main/filters_pl.json",
	},
	gitHeurekaReviewsUrl: {
		cs: "https://raw.githubusercontent.com/NatimaFilip/natima_eshop_files/refs/heads/main/heureka_reviews_cz.json",
		sk: "https://raw.githubusercontent.com/NatimaFilip/natima_eshop_files/refs/heads/main/heureka_reviews_sk.json",
		pl: "https://raw.githubusercontent.com/NatimaFilip/natima_eshop_files/refs/heads/main/data/ceneo_reviews_pl.json" /*ceneo*/,
	},
	laboratoryAnalysisText: {
		cs: "Laboratorně testováno",
		sk: "Laboratórne testované",
		pl: "Testowano laboratoryjnie",
	},
	clientUrl: {
		cs: "https://www.natima.cz/klient",
		sk: "https://www.natima.sk/klient",
		pl: "https://www.natima.pl/centrum-klientow",
	},
	vhodnePro: {
		cs: "Vhodné pro:",
		sk: "Vhodné pre:",
		pl: "Odpowiednie dla:",
	},
	kosikUrl: {
		cs: "/kosik",
		sk: "/kosik",
		pl: "/koszyk",
	},
	emptyCartBestsellersUrl: {
		cs: "/nejprodavanejsi",
		sk: "/najpredavanejsie",
		pl: "/najczesciej-kupowane",
	},
	emptyCartShowAllBestsellers: {
		cs: "Zobrazit všechny nejprodávanější",
		sk: "Zobraziť všetky najpredávanejšie",
		pl: "Zobacz wszystkie najczęściej kupowane",
	},
	emptyCartHeurekaBadgeTitle: {
		cs: "Heureka.cz - ověřené hodnocení obchodu ",
		sk: "Heureka.sk - overené hodnotenie obchodu ",
		pl: "Ceneo - zaufane opinie o sklepie ",
	},
	emptyCartHeurekaReviewsUrl: {
		cs: "https://obchody.heureka.cz/",
		sk: "https://obchody.heureka.sk/",
		pl: "https://www.ceneo.pl/sklepy/",
	},
	emptyCartHeurekaBadgeImgBase: {
		cs: "https://im9.cz/",
		sk: "https://im9.cz/sk/",
		pl: "https://im9.cz/",
	},

	nahoru: {
		cs: "Nahoru",
		sk: "Hore",
		pl: "Do góry",
	},

	currencySymbol: {
		cs: "Kč",
		sk: "€",
		pl: "zł",
	},

	measuringUnitSingulars: {
		cs: {
			kapslí: "kapsle",
			tablet: "tableta",
			tobolek: "tobolka",
			tabletek: "tabletka",
			dávek: "dávka",
			dávky: "dávka",
			produkty: "produkt",
			produktů: "produkt",
		},
		sk: {
			kapsúl: "kapsula",
			kapsula: "kapsula",
			tabliet: "tableta",
			tablietek: "tabletka",
			dávok: "dávka",
			dávky: "dávka",
			produktov: "produkt",
			produkty: "produkt",
		},
		pl: {
			kapsułek: "kapsułka",
			kapsułki: "kapsułka",
			tabletek: "tableta",
			saszetek: "saszetka",
			pastylek: "pastylka",
			gumisiów: "gumiś",
			dawek: "dawka",
			produktów: "produkt",
			produkty: "produkt",
		},
	},

	showAll: {
		cs: "Zobrazit vše",
		sk: "Zobraziť všetko",
		pl: "Zobacz wszystko",
	},

	skladem: {
		cs: "Skladem",
		sk: "Skladom",
		pl: "Na stanie",
	},
	nedostupne: {
		cs: "Momentálně nedostupné",
		sk: "Momentálne nedostupné",
		pl: "Chwilowo niedostępne",
	},
	doKosiku: {
		cs: "Do košíku",
		sk: "Do košíka",
		pl: "Do koszyka",
	},
	// --- Raventic search widgets (results + dropdown). SK/PL machine-translated; review. ---
	raventicNoResults: {
		cs: "Nic jsme nenašli, zkuste to znovu",
		sk: "Nič sme nenašli, skúste to znova",
		pl: "Nic nie znaleźliśmy, spróbuj ponownie",
	},
	raventicResultsTitle: {
		cs: "Hledáme",
		sk: "Hľadáme",
		pl: "Szukaj",
	},
	raventicNoQueryTitle: {
		cs: "Produkty",
		sk: "Produkty",
		pl: "Produkty",
	},
	raventicCategoriesTitle: {
		cs: "Kategorie",
		sk: "Kategórie",
		pl: "Kategorie",
	},
	raventicManufacturersTitle: {
		cs: "Výrobce",
		sk: "Výrobca",
		pl: "Producent",
	},
	raventicPriceTitle: {
		cs: "Cena",
		sk: "Cena",
		pl: "Cena",
	},
	raventicFiltersTitle: {
		cs: "Filtry",
		sk: "Filtre",
		pl: "Filtry",
	},
	raventicFilterButton: {
		cs: "Zobrazit filtry",
		sk: "Zobraziť filtre",
		pl: "Pokaż filtry",
	},
	raventicClearAllFilters: {
		cs: "Zrušit všechny filtry",
		sk: "Zrušiť všetky filtre",
		pl: "Usuń wszystkie filtry",
	},
	raventicParamDescription: {
		cs: "Popis",
		sk: "Popis",
		pl: "Opis",
	},
	raventicParamRating: {
		cs: "Hodnocení",
		sk: "Hodnotenie",
		pl: "Ocena",
	},
	raventicParamReviewCount: {
		cs: "Počet recenzí",
		sk: "Počet recenzií",
		pl: "Liczba recenzji",
	},
	raventicParamAltImage: {
		cs: "Alternativní obrázek",
		sk: "Alternatívny obrázok",
		pl: "Alternatywny obrazek",
	},
	raventicParamStock: {
		cs: "Skladem",
		sk: "Skladom",
		pl: "Na stanie",
	},
	raventicBrandsTitle: {
		cs: "Značky",
		sk: "Značky",
		pl: "Marki",
	},
	raventicArticlesTitle: {
		cs: "Články",
		sk: "Články",
		pl: "Artykuły",
	},
	raventicAddToCart: {
		cs: "DO KOŠÍKU",
		sk: "DO KOŠÍKA",
		pl: "DO KOSZYKA",
	},
	raventicWelcome: {
		cs: "Najděte přesně to, co hledáte!",
		sk: "Nájdite presne to, čo hľadáte!",
		pl: "Znajdź dokładnie to, czego szukasz!",
	},
	raventicRecommendedProducts: {
		cs: "Top produkty",
		sk: "Top produkty",
		pl: "Top produkty",
	},
	raventicFoundProducts: {
		cs: "Top produkt",
		sk: "Top produkt",
		pl: "Top produkt",
	},
	raventicSearchingFor: {
		cs: "Hledáme frázi",
		sk: "Hľadáme frázu",
		pl: "Szukamy frazy",
	},
	raventicWouldYouSearchFor: {
		cs: "chcete raději hledat",
		sk: "chcete radšej hľadať",
		pl: "czy chcesz raczej wyszukać",
	},
	raventicShowAll: {
		cs: "ZOBRAZIT VŠECHNY PRODUKTY",
		sk: "ZOBRAZIŤ VŠETKY PRODUKTY",
		pl: "POKAŻ WSZYSTKIE PRODUKTY",
	},
	raventicCloseLabel: {
		cs: "Zavřít vyhledávání",
		sk: "Zavrieť vyhľadávanie",
		pl: "Zamknij wyszukiwanie",
	},
	raventicClearLabel: {
		cs: "Vymazat hledání",
		sk: "Vymazať hľadanie",
		pl: "Wyczyść wyszukiwanie",
	},
	sharePrefix: {
		cs: "Sdílet ",
		sk: "Zdieľať ",
		pl: "Udostępnij ",
	},
	shareCopyLink: {
		cs: "Zkopírovat odkaz",
		sk: "Skopírovať odkaz",
		pl: "Kopiuj link",
	},
	shareLinkCopied: {
		cs: "Odkaz byl zkopírován",
		sk: "Odkaz bol skopírovaný",
		pl: "Link został skopiowany",
	},
	shareClose: {
		cs: "Zavřít",
		sk: "Zavrieť",
		pl: "Zamknij",
	},
	shareFacebook: {
		cs: "Sdílet na Facebooku",
		sk: "Zdieľať na Facebooku",
		pl: "Udostępnij na Facebooku",
	},
	shareWhatsapp: {
		cs: "Sdílet na WhatsApp",
		sk: "Zdieľať na WhatsApp",
		pl: "Udostępnij na WhatsApp",
	},
	shareEmail: {
		cs: "Sdílet e-mailem",
		sk: "Zdieľať e-mailom",
		pl: "Udostępnij e-mailem",
	},
	cartGiftsTitle: {
		cs: "Dárky k objednávce",
		sk: "Darčeky k objednávke",
		pl: "Prezenty do zamówienia",
	},
	cartGiftOrderMore: {
		cs: "Objednejte ještě za <strong>{price}</strong> a vyberte si z hodnotnějších dárků.",
		sk: "Objednajte si ešte za <strong>{price}</strong> a vyberte si z hodnotnejších darčekov.",
		pl: "Zwiększ wartość zamówienia o <strong>{price}</strong> i zyskaj dostęp do bardziej atrakcyjnych prezentów.",
	},
	cartChooseShipping: {
		cs: "Zvolte způsob dopravy",
		sk: "Zvoľte spôsob dopravy",
		pl: "Wybierz sposób dostawy",
	},
	cartChoosePayment: {
		cs: "Zvolte způsob platby",
		sk: "Zvoľte spôsob platby",
		pl: "Wybierz sposób płatności",
	},
	cartCouponKeyword: {
		cs: "KUPON",
		sk: "KUPÓN",
		pl: "KUPON",
	},
	cartBillingDeliveryAddress: {
		cs: "Doručovací a fakturační adresa",
		sk: "Doručovacia a fakturačná adresa",
		pl: "Adres dostawy i adres rozliczeniowy",
	},
	cartDeliveryWhen: {
		cs: "Nejdříve můžeme doručit",
		sk: "Najskôr môžeme doručiť",
		pl: "Najwcześniej możemy dostarczyć",
	},
	cartPriceWithVat: {
		cs: "Cena s DPH",
		sk: "Cena s DPH",
		pl: "Cena z VAT",
	},
	cartPickupWithin60Min: {
		cs: "k vyzvednutí do 60 minut",
		sk: "na vyzdvihnutie do 60 minút",
		pl: "do odbioru w ciągu 60 minut",
	},
	cartPickupUntilMorning: {
		cs: "k vyzvednutí do 9:00",
		sk: "na vyzdvihnutie do 9:00",
		pl: "do odbioru do 9:00",
	},
	cartPickupOn: {
		cs: "k vyzvednutí",
		sk: "na vyzdvihnutie",
		pl: "do odbioru",
	},
	cartDayOn0: {
		cs: "v neděli",
		sk: "v nedeľu",
		pl: "w niedzielę",
	},
	cartDayOn1: {
		cs: "v pondělí",
		sk: "v pondelok",
		pl: "w poniedziałek",
	},
	cartDayOn2: {
		cs: "v úterý",
		sk: "v utorok",
		pl: "we wtorek",
	},
	cartDayOn3: {
		cs: "ve středu",
		sk: "v stredu",
		pl: "w środę",
	},
	cartDayOn4: {
		cs: "ve čtvrtek",
		sk: "vo štvrtok",
		pl: "w czwartek",
	},
	cartDayOn5: {
		cs: "v pátek",
		sk: "v piatok",
		pl: "w piątek",
	},
	cartDayOn6: {
		cs: "v sobotu",
		sk: "v sobotu",
		pl: "w sobotę",
	},
	cartChristmasZboxWarning: {
		cs: "<b>POZOR</b>: Vaše objednávka se <b>nevleze do Z-BOXU!</b> Při volbě Z-BOXU bude Vaše objednávka přesměrována na nejbližší odběrné místo Zásilkovny.",
		sk: "<b>POZOR</b>: Vaša objednávka sa <b>nezmestí do Z-BOXU!</b> Pri voľbe Z-BOXU bude Vaša objednávka presmerovaná na najbližšie odberné miesto Zásielkovne.",
		pl: "",
	},
	cartChristmasPickupBoxWarning: {
		cs: "<b>POZOR</b>: Vaše objednávka se <b>nevleze do výdejních boxů!</b> Při volbě výdejního boxu bude Vaše objednávka přesměrována na fyzické odběrné místo.",
		sk: "",
		pl: "",
	},
	cartChristmasPaczkomatWarning: {
		cs: "",
		sk: "",
		pl: "<b>UWAGA</b>: Twoje zamówienie<b> nie zmieści się do Paczkomatu (Parcel Locker)!</b> Prosimy o wybranie <b>PaczkoPunktu (Parcel Point)</b>. W przypadku wyboru Paczkomatu Twoje zamówienie zostanie przekierowane do PaczkoPunktu.",
	},
	checkoutZipDigitsOnly: {
		cs: "PSČ smí obsahovat jen číslice.",
		sk: "PSČ môže obsahovať len číslice.",
		pl: "Kod pocztowy może zawierać tylko cyfry.",
	},
	checkoutStreetHouseNumber: {
		cs: "Uveďte prosím číslo popisné (např. Kwiatowa 12).",
		sk: "Uveďte prosím súpisné číslo (napr. Kwiatowa 12).",
		pl: "Podaj numer domu (np. Kwiatowa 12).",
	},
	checkoutFoxentryInvalid: {
		cs: "Opravte prosím neplatnou adresu.",
		sk: "Opravte prosím neplatnú adresu.",
		pl: "Popraw nieprawidłowy adres.",
	},
};

/**
 * Return the string for `key` in the active language (window.NAT.lang).
 * Falls back to Czech, then to the key name, and warns on a missing key so
 * gaps in a big translations file are easy to spot in the console.
 */
window.NAT.translations = function (key) {
	const entry = translationsStrings[key];
	if (!entry) {
		console.warn(`[NAT.translations] missing translation key: "${key}"`);
		return key;
	}
	return entry[window.NAT.lang] ?? entry.cs ?? key;
};
